<script setup lang="ts">
import { ChevronsUpDownIcon, FolderGit2Icon } from '@lucide/vue'

type Props = {
  /** The current repository's name — shown bold under the "Repository" caption. */
  name: string
  /** Shown in small text under the name for a shared repository you don't own. */
  owner?: string
  isShrunk?: boolean
}

defineProps<Props>()
</script>

<template>
  <button
    type="button"
    class="flex items-center gap-2.5 pr-2.5 pl-1.5 rounded-ds-md hover:bg-background transition-colors duration-ds-fast ease-ds-standard cursor-pointer"
    :class="[
      isShrunk ? 'max-w-50 ' : 'max-w-65',
      owner ? 'py-0.75' : 'py-1.5'
    ]"
  >
    <span class="flex items-center justify-center size-7.5 rounded-ds-sm bg-accent text-brand shrink-0">
      <FolderGit2Icon
        class="size-4"
        aria-hidden="true"
      />
    </span>
    <span class="flex flex-col leading-tight items-start overflow-hidden">
      <span
        class="text-[11px] font-bold uppercase tracking-ds-wide text-muted-foreground/35"
        :class="owner ? 'leading-[100%]' : undefined"
      >Repository</span>
      <span
        class="w-full text-[15px] font-bold text-foreground truncate text-left"
        :class="owner ? 'leading-[100%]' : undefined"
      >{{ name }}</span>
      <span
        class="w-full text-[10px] font-medium text-muted-foreground truncate text-left"
      >{{ owner }}</span>
    </span>
    <ChevronsUpDownIcon
      class="size-4 text-muted-foreground shrink-0"
      aria-hidden="true"
    />
  </button>
</template>
